// This renders the app to the DOM. That's it.

import React from "react";
import { createRoot } from 'react-dom/client';

import App from "./App.jsx";

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<App />);

